exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body,html{margin:0;font-family:Nunito,sans-serif}#app,body,html{height:100%}#THREEContainer{position:absolute;top:0;bottom:0;height:100%;width:100%;z-index:-100}.post-parsed{position:absolute;bottom:10px;left:10px;z-index:100}.above-fold,.svg-paste{height:100%;display:flex;flex-direction:column;align-items:center;justify-content:center}.above-fold>*,.svg-paste>*{margin:20px auto}.above-fold form,.svg-paste form{display:block;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-81ebf204","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 59
// module chunks = 0